import { useState, useEffect } from "react";
import { MagCardVotos } from "../../components/cards";
import { getDetallesVotosPublic, getMagPublic, getOpcionesMagistrdosPublic, getVotosVotacionActivaPublic } from "../../services/juntanominadora";
import * as React from "react";

const ProyeccionVotos: React.FC = () => {
    const [show, setshow] = useState(false);
    const [candidatosElectos, setCandidatosElectos] = useState<any[]>([]);
    const [votosVotacionActiva, setvotosVotacionActiva] = useState<any[]>([]);
    const [limite, setlimite] = useState<Number>(86);
    const [postulantes, setpostulantes] = useState<any[]>([]);
    const [upd, setupd] = useState(false);
    
    const getCards = () => {
        const content = [];
        for (let i = 0; i < 3; i++) {
            const elements:any[] = [];
            for (let j = 0; j < 15; j++) {
                const idx: number = j + (15 * i)
                const posttemp = postulantes.filter((val) => { return val.id !== "1" })
                const cand: any = posttemp[idx];
                
                if (cand) {
                    
                    let votosDelCandidato = votosVotacionActiva.filter((va) => va.candidato_id === cand.id).length;
                    const candidatoElecto = candidatosElectos.filter(v => { return v.candidato_id === cand.id });
                    if(candidatoElecto[0]?.votos){
                        votosDelCandidato = candidatoElecto[0]?.votos;
                    }

                    elements.push(
                        <MagCardVotos key={cand.id} position={votosDelCandidato} mark={""} name={cand.nombre} disabled={false} selected={candidatoElecto.length === 1} setselected={() => {}} />
                    );
                };
            };

            let mainContainer = React.createElement("div", { className: "row mx-auto my-2", key: "row" + i }, elements);
            content.push(mainContainer);
        };
        return content;
    };

    useEffect(() => {
        if (!upd) {
            setupd(true);
            getMagPublic().then(v => {
                if (v.data.successed) {
                    const mag: any[] = v.data.candidatos;
                    setpostulantes(mag)
                };
            });
        }
        const inv = setInterval(() => {
            setshow(false);

            getOpcionesMagistrdosPublic().then((v) => {
                if (v.data.successed) {
                    const opciones = v.data.content;
                    const limite = opciones.find((o:any) => o.name === "limite");
                    setlimite(limite ? parseInt(limite.value) : 86);
                };
            });

            getVotosVotacionActivaPublic().then((v) => {
                if (v.data.successed) {
                    setvotosVotacionActiva(v.data.content);
                };
            });

            getDetallesVotosPublic().then((v) => {
                if (v.data.successed) {
                    const votes = v.data.votos; 
                    const candidatosElectos: any[] = votes.filter((v: any) => { return (v.votos >= limite && v.candidato_id !== "1") });
                    setCandidatosElectos(candidatosElectos);
                };
            });
        }, 2000);
        return () => clearInterval(inv);
    }, [upd, show, limite]);

    if (show) {
        return (
            <div className="container-fluid d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
                <h5><b>Esperando Resultados...</b></h5>
            </div>
        )
    };
    return (
        <div className="container-fluid py-3 text-center">
            <div className="d-flex align-items-center justify-content-between">
                <img className="mx-3 my-1 aling-right" src="images/escudo.png" alt="" height={65} />
                <h1 className="py-2 w-100 position-absolute start-0"><b>CANDIDATOS A MAGISTRADOS</b></h1>
                <h4 className="w-100 position-absolute start-0" style={{top: "4.2rem", fontSize: "1.3rem"}}><b>ELECTOS {candidatosElectos.length}/15</b></h4>
                <img className="mx-3 my-1 aling-right" src="images/logo.png" alt="" height={65} />
            </div>
            {getCards()}
        </div>
    )
};

export default ProyeccionVotos;
